<template>
  <ListPicking />
</template>

<script>
import ListPicking from '@/components/PICKING/ListPicking.vue';

export default {
  name: 'HomePicking',
  components: {
    ListPicking,
  },
}
</script>
